// Config
import './vue-config'

//Polyfills
import Polyfills from './utils/polyfill'
Polyfills.load()
//End Polyfills

import Vue from 'vue'
import App from './App.vue'

import VueScrollTo from 'vue-scrollto'
Vue.use(VueScrollTo)

import Raven from 'raven-js'
import RavenVue from 'raven-js/plugins/vue'
Raven
  .config('@@sentryDSN', {
    environment: process.env.NODE_ENV,
    release: APP_VERSION,
    whitelistUrls: [@@sentryWhiteList],
includePaths: [@@sentryIncludePaths],
ignoreErrors: [@@sentryIgnoreErrors]
  })
  .addPlugin(RavenVue, Vue)
  .install()

const d = document
if (!d.getElementsByTagName('swaychat-widget').length) {
  const s = d.createElement("swaychat-widget")
  d.body.appendChild(s)
}

new Vue({
  el: 'swaychat-widget',
  name: 'SwayChat Widget',
  render: h => h(App)
})
